import { withRouter, Redirect } from 'react-router-dom'
import React from 'react'
import intl from 'react-intl-universal'
import Popup from 'react-popup'
import { connect } from 'react-redux'
import { getPacks, refreshPacks, setFilters, searchPackagesByOrder, clearPackagesSearch } from '../actions/PackActions'
import PackListItem from './PackListItem'

const PACKS_REFRESH_INTERVAL_MS = 60000

function getPackListItem(pack, wozek) {
  return (
    <PackListItem
      key={pack.id}
      pack={pack}
      wozek={wozek}
    />
  )
}

const mapStateToProps = state => ({
  authenticated: state.auth.session.id !== false,
  wozek: state.config.wozek,
  use_multi_search: state.config.use_multi_search,
  packs: state.pack.packs,
  filters: state.pack.filters,
  multiSearchResult: state.pack.multi_search_result
})

const mapDispatchToProps = dispatch => ({
    getPacksAction: () => dispatch(getPacks()),
    refreshPacksAction: () => dispatch(refreshPacks()),
    setFiltersAction: (filters) => dispatch(setFilters(filters)),
    searchPackagesByOrderAction: (query) => dispatch(searchPackagesByOrder(query)),
    clearPackagesSearchAction: () => dispatch(clearPackagesSearch()),
})

class PacksComponent extends React.Component {

  state = {
    search: '',
    multiSearchQuery: ''
  }

  componentDidMount() {
    const { getPacksAction, authenticated } = this.props
    if(authenticated) getPacksAction()
    this.refreshTimer = setInterval(this.refreshPacks, PACKS_REFRESH_INTERVAL_MS)
    document.addEventListener('visibilitychange', this.onVisibilityChange)
  }

  componentWillUnmount() {
    clearInterval(this.refreshTimer)
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
  }

  refreshPacks = () => {
    const { refreshPacksAction, authenticated } = this.props
    // karta w tle albo poprzednie odświeżenie jeszcze trwa - pomijamy cykl
    if (!authenticated || document.hidden || this.isRefreshing) return
    this.isRefreshing = true
    refreshPacksAction().then(() => {
      this.isRefreshing = false
    })
  }

  onVisibilityChange = () => {
    if (!document.hidden) this.refreshPacks()
  }

  onSearchChange = (event) => {
    this.setState({ search: event.target.value })
  }

  onMultiSearchChange = (event) => {
    const { clearPackagesSearchAction } = this.props
    const value = event.target.value
    this.setState({ multiSearchQuery: value })
    if (!value) {
      clearPackagesSearchAction()
    }
  }

  handleMultiSearchSubmit = (event) => {
    event.preventDefault()
    const { searchPackagesByOrderAction } = this.props
    const query = this.state.multiSearchQuery.trim()
    if (query) {
      searchPackagesByOrderAction(query)
    }
  }

  selectPack = (event) => {
    const {selectPackAction} = this.props
    const id = parseInt(event.currentTarget.getAttribute('data-id'))
    const is_multi = parseInt(event.currentTarget.getAttribute('data-multi'))
    const important = parseInt(event.currentTarget.getAttribute('data-important'))
    selectPackAction(id, is_multi, important)
  }

  filterClick = (e) => {
    const { filters, setFiltersAction } = this.props
    let new_filters = {
      ...filters,
      [e.currentTarget.name]: e.currentTarget.checked
    }
    setFiltersAction(new_filters)
  }

  componentDidUpdate(prevProps) {
    const { multiSearchResult } = this.props
    if (prevProps.multiSearchResult !== multiSearchResult &&
        multiSearchResult && multiSearchResult.packages.length === 0) {
      Popup.alert(
        multiSearchResult.order_found_outside_active_pack
          ? intl.get('Zamówienie nie znajduje się w aktywnym PAK/MULTIPAK')
          : intl.get('Nie znaleziono zamówienia w dostępnych pakietach')
      )
    }
  }

  render() {
    const {authenticated, packs, wozek, filters, use_multi_search, multiSearchResult} = this.props
    const {search, multiSearchQuery} = this.state

    if(!authenticated) return (<Redirect to='/login' />)

    let packListItems;

    if (packs) {
      const filteredPacks = packs.filter(pack =>
        pack.name.toLowerCase().includes(search.trim().toLowerCase())
      )
      packListItems = filteredPacks.map(pack => getPackListItem(pack, wozek));
    }
    if (packs) {
      const showSearchResults = multiSearchResult && multiSearchResult.packages.length > 0
      return (
        <div>
          <div className="filters-wrap">
            <div className="filters">
              <input type="text"
                     className="search-input"
                     placeholder={intl.get('Szukaj po nazwie')}
                     value={search}
                     onChange={this.onSearchChange}/>
              <label htmlFor="filter_pak" className={filters.pak?'checked':''}>
                <input type="checkbox"
                       id="filter_pak"
                       name="pak"
                       onChange={this.filterClick}
                       checked={filters.pak}/>
                Pak
              </label>
              <label htmlFor="filter_multi" className={filters.multi?'checked':''}>
                <input type="checkbox"
                       id="filter_multi"
                       name="multi"
                       onChange={this.filterClick}
                       checked={filters.multi}/>
                Multi
              </label>
            </div>
            {use_multi_search &&
              <form className="filters multi-order-search" onSubmit={this.handleMultiSearchSubmit}>
                <input type="text"
                       className="search-input"
                       placeholder={intl.get('Numer zamówienia / kod paku / wózka / przesyłki')}
                       value={multiSearchQuery}
                       onChange={this.onMultiSearchChange}/>
                <input type="submit" className="pull-right" value={intl.get('Szukaj')} />
              </form>
            }
          </div>
          <h1>
            <div className="breadcrumb">
              <span>{intl.get('Dostępne zamówienia na pakowalni')}:</span>
            </div>
          </h1>
          {showSearchResults &&
            <div className="elem-list show_pak show_multi">
              {multiSearchResult.packages.map(pack => getPackListItem(pack, wozek))}
            </div>
          }
          {!showSearchResults &&
            <div className={`elem-list ${filters.pak?'show_pak':''} ${filters.multi?'show_multi':''}`}>
              {packListItems}
            </div>
          }
        </div>
      )
    } else {
      return (<div></div>)
    }
  }
}
const Packs = connect(mapStateToProps, mapDispatchToProps)(PacksComponent)
export default withRouter(Packs)
